/**
 * The save bar's error line: what failed, and why when the server said so. Every failed request
 * used to read "Failed to save assignments. Please try again." whatever the API had answered —
 * a 404 for a combination another scoring had just taken read the same as a network drop
 * (PREC-4180).
 */
export const saveErrorText = (error: unknown, fallback: string): string => {
	const data = (error as { data?: { message?: unknown } } | null)?.data;
	const message = Array.isArray(data?.message) ? data.message.join("; ") : data?.message;

	return typeof message === "string" && message.trim()
		? `${fallback} (${message.trim()})`
		: fallback;
};
